import createVerityLogger from "@yujacorp/verity-logger";
import apiClient from "../api-client";
import getSystemInfo from "./system-info";

const verityLogger = createVerityLogger({
	platform: "web",
	baseUrl: `/api/verity/audit-log`,
	fetch: apiClient.fetch.bind(apiClient),
	getDynamicContext: () => ({
		source: "verity",
		page: {
			url: window.location.href,
			ancestorOrigins: [...(window.location.ancestorOrigins ?? [document.referrer.replace(/\/$/, "") || ""])],
		},
	}),
});
export default verityLogger;

export async function initVerityLogger() {
	apiClient.emitter.on("refresh", (response: Response) =>
		verityLogger.authentication.refreshToken.refreshed(response.ok, response.status),
	);
	apiClient.emitter.on("access-token-updated", (jwt) =>
		verityLogger.stateStore.setState((currState) => ({
			...currState,
			context: { ...currState.context, userId: jwt?.uid || undefined },
		})),
	);

	const { fingerprint, ...remainingSystemDetails } = await getSystemInfo();
	await verityLogger.stateStore.setState((currState) => ({
		...currState,
		context: {
			fingerprint,
			systemDetails: remainingSystemDetails,
		},
	}));
}
